<template>
  <div class="nft_wrapper nft_log" id="myNft">
    <!-- title -->
    <div class="main_top">
      <h1>
        <img src="images/basic/icon/back.svg" onclick="history.back()" class="back" />
        NFT 구매내역
      </h1>
      <a class="h1_div"> </a>
    </div>
    <div class="div_padding"></div>
    <div class="stat">
      <ul class="list horizon">
        <li class="items">
          <ul class="item">
            <li class="line1px-bottom" v-for="(nft , index) in resultList" :key="index">
              <div class="thumb">
                <img :src="`/asset/images/nft/nft${nft.nftTypeCode.replace('NFT','')}.png`" alt="">
              </div>
              <div class="text">
                <h3>{{nft.nftSn}}</h3>
                <template v-if="nft.nftDownPaymentDate != undefined & nft.nftDownPaymentDate != ''">
                  <p>{{nft.nftBalanceDate}}일까지 할부 납부</p>
                  <p class="remain"><span>{{nft.nftDownPayment}}</span> / {{nft.nftBalance}}</p>
                </template>
                <template v-else>
                  <p class="price">₩ {{(nft.nftTypeCode.replace('NFT','')*10000).toLocaleString('ko-KR')}}</p>
                </template>
                <p class="date">{{nft.nftRegDate}} 구매</p>
              </div>
            </li>
            
            <!--
            <li class="line1px-bottom">
              <div class="thumb">
                <img src="images/basic/img/nft-roulette.png" alt="">
              </div>
              <div class="text">
                <h3>NFT Holder Roulette</h3>
                <p>2023년 3월 14일까지 할부 납부</p>
                <p class="remain"><span>84270293</span> / 26120293.021 TRX </p>
                <p class="date">2022.03.15 PM 6:39:17 구매</p>
              </div>
            </li>
            <li class="line1px-bottom">
              <div class="thumb">
                <img src="images/basic/img/nft-dice.png" alt="">
              </div>
              <div class="text">
                <h3>NFT Holder Roulette</h3>
                <p class="price">₩ 20,000,000 </p>
                <p class="date">2022.03.15 PM 6:39:17 구매</p>
              </div>
            </li>
            <li class="line1px-bottom">
              <div class="thumb">
                <img src="images/basic/img/nft-slot.png" alt="">
              </div>
              <div class="text">
                <h3>NFT Holder Roulette</h3>
                <p class="price">₩ 100,000,000 </p>
                <p class="date">2022.03.15 PM 6:39:17 구매</p>
              </div>
            </li>
            -->
          </ul>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import $ from 'jquery'
import { fetchBuyInfo } from "@/api/nft";
export default {
  data() {
     return{
        resultList:[],
     }
  },
  created() {
   this.getBuyInfo();
  },
  mounted() {
    $('.test').text('제이쿼리 적용하는 구간')
  },
   methods: {
    getBuyInfo() {
      fetchBuyInfo( )
        .then(({ data }) => {
          this.resultList = data.resultList;
        })
    },
   }
}
</script>

<style scoped>

</style>